import React from "react";
import CustomDrawer from "../Drawer";
import CustomFormik from "./CustomFormik";
import { CustomDrawerFormProps } from "./type";

const FormDrawer = ({ drawerProps, ...rest }: CustomDrawerFormProps) => {
  return (
    <React.Fragment>
      <CustomDrawer {...drawerProps}>
        <CustomFormik {...rest} />
      </CustomDrawer>
    </React.Fragment>
  );
};
export default FormDrawer;
